import React from 'react';
import { FieldRadioToggle } from '.';
import { FieldRadioToggleWithReduxProps } from './types';

export const FieldRadioToggleWithRedux = ({
  input: { name, onChange, value },
  options,
  isDisabled,
  ...html
}: FieldRadioToggleWithReduxProps) => {
  return (
    <FieldRadioToggle
      {...html}
      name={name}
      onChange={e => {
        /**
         * CurrentTarget changes all values to strings. Since we use booleans in some radio toggles
         * we will need to convert currentTarget.value to its correct type.
         */
        const newValue = e.currentTarget.value;
        const isBoolean = typeof options?.[0]?.value === 'boolean';
        const isTrue = isBoolean && newValue === 'true';
        const isFalse = isBoolean && newValue === 'false';

        onChange(isTrue ? true : isFalse ? false : e.currentTarget.value);
      }}
      value={value}
      options={options}
      disabled={isDisabled}
    />
  );
};
